var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { TemplateVersion } from "./../models/V1/DocumentTemplates/TemplateVersion";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { TemplateResponse } from "./../models/V1/DocumentTemplates/TemplateResponse";
import { DataSourceField } from "./../models/V1/DocumentTemplates/DataSourceField";
import { PdfFieldResponse } from "./../models/V1/DocumentTemplates/PdfFieldResponse";
import { MappingItem } from "./../models/V1/DocumentTemplates/MappingItem";
import { CompanyTemplateSearchResult } from "./../models/V1/DocumentTemplates/TemplateSearch/CompanyTemplateSearchResult";
import { VatRegTemplateSearchResult } from "./../models/V1/DocumentTemplates/TemplateSearch/VatRegTemplateSearchResult";
export class DocumentTemplates {
  /**
   * Creates an instance of DocumentTemplates.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof DocumentTemplates
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param CloneTemplateVersionToDraftRq_ _cloneTemplateVersionToDraftRq
   * @returns Promise<CloneTemplateVersionToDraftRq_>
   * @memberof DocumentTemplates
   */
  cloneTemplateVersionToDraft(pCloneTemplateVersionToDraftRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/clone",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pCloneTemplateVersionToDraftRq.templateId, required: true },
      { name: "templateVersion", value: pCloneTemplateVersionToDraftRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: TemplateVersion },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateDraftTemplateVersionRq_ _createDraftTemplateVersionRq
   * @returns Promise<CreateDraftTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  createDraftTemplateVersion(pCreateDraftTemplateVersionRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "templateId", value: pCreateDraftTemplateVersionRq.templateId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: TemplateVersion }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetAllRq_ _getAllRq
   * @returns Promise<GetAllRq_>
   * @memberof DocumentTemplates
   */
  getAll(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: TemplateResponse, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateRq_ _createRq
   * @returns Promise<CreateRq_>
   * @memberof DocumentTemplates
   */
  create(pCreateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pCreateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 201, clazz: TemplateResponse }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetTemplateVersionRq_ _getTemplateVersionRq
   * @returns Promise<GetTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  getTemplateVersion(pGetTemplateVersionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pGetTemplateVersionRq.templateId, required: true },
      { name: "templateVersion", value: pGetTemplateVersionRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: TemplateVersion },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteTemplateVersionRq_ _deleteTemplateVersionRq
   * @returns Promise<DeleteTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  deleteTemplateVersion(pDeleteTemplateVersionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}",
      "DELETE",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pDeleteTemplateVersionRq.templateId, required: true },
      { name: "templateVersion", value: pDeleteTemplateVersionRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param EnableTemplateVersionRq_ _enableTemplateVersionRq
   * @returns Promise<EnableTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  enableTemplateVersion(pEnableTemplateVersionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/enable",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pEnableTemplateVersionRq.templateId, required: true },
      { name: "templateVersion", value: pEnableTemplateVersionRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DisableTemplateVersionRq_ _disableTemplateVersionRq
   * @returns Promise<DisableTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  disableTemplateVersion(pDisableTemplateVersionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/enable",
      "DELETE",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pDisableTemplateVersionRq.templateId, required: true },
      { name: "templateVersion", value: pDisableTemplateVersionRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetDataSourceRq_ _getDataSourceRq
   * @returns Promise<GetDataSourceRq_>
   * @memberof DocumentTemplates
   */
  getDataSource(pGetDataSourceRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/datasource",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "templateId", value: pGetDataSourceRq.templateId, required: true }]);
    client.addBody({ value: pGetDataSourceRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: DataSourceField, isArray: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetEmptyDataSourceRq_ _getEmptyDataSourceRq
   * @returns Promise<GetEmptyDataSourceRq_>
   * @memberof DocumentTemplates
   */
  getEmptyDataSource(pGetEmptyDataSourceRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/datasource/empty",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "templateId", value: pGetEmptyDataSourceRq.templateId, required: true }]);
    client.addBody({ value: pGetEmptyDataSourceRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: DataSourceField, isArray: true },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetRq_ _getRq
   * @returns Promise<GetRq_>
   * @memberof DocumentTemplates
   */
  get(pGetRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates/{templateId}", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "templateId", value: pGetRq.templateId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: TemplateResponse },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof DocumentTemplates
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates/{templateId}", "PUT", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "templateId", value: pUpdateRq.templateId, required: true }]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetPdfTemplateRq_ _getPdfTemplateRq
   * @returns Promise<GetPdfTemplateRq_>
   * @memberof DocumentTemplates
   */
  getPdfTemplate(pGetPdfTemplateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/pdftemplate",
      "GET",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pGetPdfTemplateRq.templateId, required: true },
      { name: "templateVersion", value: pGetPdfTemplateRq.templateVersion, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isFile: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadPdfTemplateRq_ _uploadPdfTemplateRq
   * @returns Promise<UploadPdfTemplateRq_>
   * @memberof DocumentTemplates
   */
  uploadPdfTemplate(pUploadPdfTemplateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/pdftemplate",
      "PUT",
      "multipart/form-data",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pUploadPdfTemplateRq.templateId, required: true },
      { name: "templateVersion", value: pUploadPdfTemplateRq.templateVersion, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadPdfTemplateRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: PdfFieldResponse },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetPreviewRq_ _getPreviewRq
   * @returns Promise<GetPreviewRq_>
   * @memberof DocumentTemplates
   */
  getPreview(pGetPreviewRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/pdf",
      "POST",
      "application/json; charset=UTF-8",
      "application/pdf, application/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pGetPreviewRq.templateId, required: true },
      { name: "templateVersion", value: pGetPreviewRq.templateVersion, required: true }
    ]);
    client.addBody({ value: pGetPreviewRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param PublishTemplateVersionRq_ _publishTemplateVersionRq
   * @returns Promise<PublishTemplateVersionRq_>
   * @memberof DocumentTemplates
   */
  publishTemplateVersion(pPublishTemplateVersionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/publish",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pPublishTemplateVersionRq.templateId, required: true },
      { name: "templateVersion", value: pPublishTemplateVersionRq.templateVersion, required: true }
    ]);
    client.addBody({ value: pPublishTemplateVersionRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param RemoveMappingRq_ _removeMappingRq
   * @returns Promise<RemoveMappingRq_>
   * @memberof DocumentTemplates
   */
  removeMapping(pRemoveMappingRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/mappings/{pdfFieldName}",
      "DELETE",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pRemoveMappingRq.templateId, required: true },
      { name: "templateVersion", value: pRemoveMappingRq.templateVersion, required: true },
      { name: "pdfFieldName", value: pRemoveMappingRq.pdfFieldName, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SaveMappingsRq_ _saveMappingsRq
   * @returns Promise<SaveMappingsRq_>
   * @memberof DocumentTemplates
   */
  saveMappings(pSaveMappingsRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/{templateId}/versions/{templateVersion}/mappings",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "templateId", value: pSaveMappingsRq.templateId, required: true },
      { name: "templateVersion", value: pSaveMappingsRq.templateVersion, required: true }
    ]);
    client.addBody({ value: pSaveMappingsRq.body, isArray: true });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: MappingItem, isArray: true },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchCompanyTemplatesRq_ _searchCompanyTemplatesRq
   * @returns Promise<SearchCompanyTemplatesRq_>
   * @memberof DocumentTemplates
   */
  searchCompanyTemplates(pSearchCompanyTemplatesRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DocumentTemplates/companytemplates", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchCompanyTemplatesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: CompanyTemplateSearchResult }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchVatRegTemplatesRq_ _searchVatRegTemplatesRq
   * @returns Promise<SearchVatRegTemplatesRq_>
   * @memberof DocumentTemplates
   */
  searchVatRegTemplates(pSearchVatRegTemplatesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/DocumentTemplates/vatregistrationtemplates",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addBody({ value: pSearchVatRegTemplatesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: VatRegTemplateSearchResult }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
